// extracted by mini-css-extract-plugin
export default {"drawerFooterContent":"DrawerFooter-module__drawerFooterContent__Oj66S","drawerFooterAction":"DrawerFooter-module__drawerFooterAction__H2id9"};